
function NotFound() {
    return (
        <div className="d-flex flex-column justify-content-center align-items-center text-center vh-100 bg-light px-3">
            <h1 className="display-3 fw-bold text-primary">404</h1>
            <p className="lead text-dark mb-3">Page Not Found</p>
            <p className="text-muted mb-4">
                The page you're looking for doesn’t exist. Let’s get you back to the FitFind experience.
            </p>
            <a href="/" className="btn btn-primary px-4 py-2 rounded-pill shadow">
                Go to Homepage
            </a>
        </div>
    );
}




export default NotFound;
